module.exports = __webpack_public_path__ + "static/32986-de6979fc00a651e59005ce1119265520.jpeg";